/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_SavedInputs */



/**
* | output |
* | --- |
* | "Preset saved successfully" |
*
* @param {Image_Export_Style_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_saved = /** @type {((inputs?: Image_Export_Style_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prereglage enregistre avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazione salvata correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительные настройки успешно сохранены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preajuste guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinição salva com sucesso")
	return /** @type {LocalizedString} */ ("Preset saved successfully")
});